var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkedIn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6256_59888)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75322 17.5287V10.2091H6.49094V17.5287H8.75322ZM8.75322 7.61468C8.73974 6.95966 8.30319 6.46094 7.59401 6.46094C6.88464 6.46094 6.42114 6.95966 6.42114 7.61468C6.42114 8.25548 6.87117 8.76863 7.56688 8.76863H7.58035C8.30319 8.76863 8.75322 8.25548 8.75322 7.61468ZM12.444 17.5287V13.3583C12.444 13.1352 12.4601 12.912 12.5258 12.7529C12.7052 12.3067 13.1136 11.8449 13.7993 11.8449C14.6975 11.8449 15.2609 12.3547 15.2609 13.3583V17.5287H17.5385V13.2468C17.5385 10.953 16.314 9.88567 14.6808 9.88567C13.3416 9.88567 12.7538 10.6343 12.4274 11.1439L12.4438 10.165H10.1702C10.2029 10.8657 10.1702 17.5287 10.1702 17.5287H12.444Z",
    fill: "#1D1D1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6256_59888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedIn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/linkedIn.3b6c732ce27bb25971b81bc02cad6636.svg";